module.exports = __webpack_public_path__ + "img/cameraDefault.07127ead.svg";